import Icon from 'veui/components/Icon'
import { IconStar } from 'dls-icons-vue'

Icon.register('star', IconStar)
